import RankingSummary from '../components/common/RankingSummary2023.vue';
import RankingPage from '../components/common/RankingPage2023.vue';
import MetaRankingPage from '../components/common/MetaRankingPage2023.vue';
import Iframe from '../components/common/Iframe.vue';
import HomeDL2023 from '../views/HomeDL2023.vue';

let routes = [
  //Dl2022 Splash page
  {
    path: '/digitalleaders2023',
    component: HomeDL2023,
    meta: {
      page: 'Digital-Leaders',
      stylesheet: 'dl2023'
    }
  },
  {
    path: '/table',
    component: Iframe,
    meta: {
      layout: 'splash'
    }
  },
  {
    path: '/digitalleaders',
    component: HomeDL2023,
    meta: {
      page: 'Digital-Leaders',
      stylesheet: 'dl2023'
    }
  },
  {
    path: '/skjahajkdsh871321765qOpUtRg_8765tT',
    component: HomeDL2023,
    meta: {
      page: 'Digital-Leaders',
      stylesheet: 'dl2023'
    }

  },
  {
    path: '/digitalleaders2023/methodology',
    component: HomeDL2023,
    beforeEnter(to, from, next) {
      window.location.href = '/assets/files/methodology2023.pdf';
    }
  },
  {
    path: '/digitalleaders2023/meta-ranking',
    component: RankingSummary,
    meta: {
      stylesheet: 'dl2023',
      pageId: '643944d89b75c55bf3b65108',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/meta-ranking2022.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
      // link:
      //   'https://www.timeshighereducation.com/student/best-universities/digital-leaders-top-universities-digital-education',
      // linkText:
      //   'See the publication by the Times Higher Education (THE) on their student and academic website '
    }
  },
  {
    path: '/digitalleaders2023/meta',
    component: MetaRankingPage,
    meta: {
      stylesheet: 'dl2023',
      pageId: '643fa6c89b75c55bf3b65147',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/meta2023.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  },
  {
    path: '/digitalleaders2023/cs',
    component: RankingPage,
    meta: {
      stylesheet: 'dl2023',
      pageId: '643955ec9b75c55bf3b65111',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/cs2023.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  },
  {
    path: '/digitalleaders2023/ds',
    component: RankingPage,
    meta: {
      stylesheet: 'dl2023',
      pageId: '6439563d9b75c55bf3b65112',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/ds2023.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  },
  {
    path: '/digitalleaders2023/entrepreneur',
    component: RankingPage,
    meta: {
      stylesheet: 'dl2023',
      pageId: '643954689b75c55bf3b6510e',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/entrepreneur2023.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  },
  {
    path: '/digitalleaders2023/online-studies',
    component: RankingPage,
    meta: {
      stylesheet: 'dl2023',
      pageId: '643956879b75c55bf3b65113',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/online2023.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  },
  {
    path: '/digitalleaders2023/business-school',
    component: RankingPage,
    meta: {
      stylesheet: 'dl2023',
      pageId: '6278cd0846758f0219c699af',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/business2022.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  },
  {
    path: '/digitalleaders2023/management',
    component: RankingPage,
    meta: {
      stylesheet: 'dl2023',
      pageId: '6439555d9b75c55bf3b6510f',
      variant: 'digitalleaders',
      fields: 'mainRanking',
      file: 'assets/files/digital2023.json' // Use https://www.convertcsv.com/csv-to-json.htm to convert CSV to JSON
    }
  }
];

export default routes;
